const luzmo = {
  appServer: 'https://app.us.luzmo.com',
  apiHost: 'https://api.us.luzmo.com',
};

export default luzmo;
